import React,{useEffect, useState} from "react";
import { Link } from "gatsby";
import "./PropertyCardBig.scss";
import propertyImg from '../../images/img_1400.jpg';
import AgentImg from '../../images/agent.jpg'
import ScrollAnimation from 'react-animate-on-scroll'; 
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../static/images/config.json";
import HTMLReactParser from "html-react-parser";
import Offertag from "../Offertag/Offertag";
import axios from "axios";
import ReapitView from "../ReapitView";
import PropertyAvailableFrom from "./PropertyAvailableFrom"

const PropertyCardBig = (props) => {
    const [team, setTeam] = React.useState(null)
    const propertyList = props.propertyList;

    useEffect(() => {
        if(propertyList.propertyNegotiator) {
            let url = process.env.GATSBY_STRAPI_SRC + `/teams?Email=${propertyList.propertyNegotiator}`;
            getItems(url);
        }
    }, []);

    const getItems = async url => {
        try {
            const { data } = await axios.get(url, { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
            if (data && data.length > 0) {
                setTeam(data[0])
            }
        } catch (error) {
            console.error(error)
        }
    }
    return (
        <React.Fragment>
            <ScrollAnimation animateIn="fadeInUp">
                <div className="property-card-big img-zoom" id={`propertyList_${props.propertyId}`}>
                    <div className="properties-wrapper">
                        <Link to={propertyList.propertyLink} className="overflow-hidden"
                          onClick={()=>{
                            sessionStorage.setItem('searchindex', props.propertyId)
                        }}
                        >
                            {props.searchResults ?
                                <React.Fragment>
                                    {propertyList?.propertyImg?.length > 0 ? 
                                        <ShowProcessedImage
                                            images={propertyList.propertyImg[0]}
                                            transforms={
                                                imageConfig.properties.images.list.sizes
                                            }
                                        /> 
                                        : 
                                        <picture>
                                            <img src={propertyImg} alt="img" />
                                        </picture>
                                    }
                                </React.Fragment> :
                                <picture>
                                    <img src={propertyList.propertyImg} alt="img" />
                                </picture>
                            }
                        </Link>
                        {propertyList.offerTag && <Offertag text={propertyList.offerTag}/>}
                    </div>
                    <div className="about-properties">
                        <div className="properties-info">
                            <div className="properties-heading">
                                <h2><Link to={propertyList.propertyLink}> {propertyList.propertyTitle}</Link></h2>
                                <span className="property-price">{propertyList.propertyPrice} {!propertyList.propertyStatus ? "PW": ""} {propertyList?.price_qualifier == "Offers In Excess" ? propertyList.price_qualifier : ""}</span>
                            </div>
                            <p>{propertyList.propertyInfo}</p>
                            <PropertyAvailableFrom available_from={propertyList.available_from} status={propertyList.status} />
                            <div className="properties-icons">
                                {parseInt(propertyList.propertyRoom) > 0 && 
                                    <span className="text">
                                        <i className="icon-bedroom"></i>
                                        <span className="sm-text">{propertyList.propertyRoom}</span>
                                    </span>
                                }

                                {parseInt(propertyList.propertyBathroom) > 0 && 
                                    <span className="text">
                                        <i className="icon-bath"></i>
                                        <span className="sm-text">{propertyList.propertyBathroom}</span>
                                    </span>
                                }

                                {parseInt(propertyList.propertyReception) > 0 && 
                                    <span className="text">
                                        <i className="icon-sofa"></i>
                                        <span className="sm-text">{propertyList.propertyReception}</span>
                                    </span>
                                }
                            </div>
                            
                            <p className="property-text">
                                {HTMLReactParser(propertyList.propertyDesc)}
                            </p>
                        </div>
                        {/* {team != null && <div className="property-agent">
                            <div className="property-agent-pic">
                                <img src={team?.Tile_Image?.url} className="property-list-neg_image" alt={team?.Name + " - tlclondon"} />
                            </div>
                            <div className="property-agent-info">
                                <span className="property-agent-name">{team?.Name}</span>
                                <div className="agent-contact">
                                    <a href={`tel:${team?.Mobile}`}>
                                        <i className="icon-phone-dark"></i> {team?.Mobile}
                                    </a>
                                    <ReapitView
                                        crmId={propertyList.crmId}
                                        dangerouslySetInnerHTML={{ 
                                            __html: `
                                                <i className="icon-mail"></i>
                                                <a class="reapit-viewing-btn cursor-pointer" property.id=${propertyList.crmId} message.appointment.title="Viewing Requested">
                                                    Book an Appointment
                                                </a>
                                            `
                                        }}
                                    />
                                </div>
                            </div>
                        </div>} */}
                    </div>
                </div>
            </ScrollAnimation>
        </React.Fragment>
    );
};

export default PropertyCardBig;
